export const formatHufPrice = (price: number) => {
  return `${price.toLocaleString('hu-HU')} Ft`;
};

export const formatEurPrice = (price: number) => {
  return `${price.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}`;
};
